// extracted by mini-css-extract-plugin
export default {"root":"iawLcj","anonymous":"aIEdxp","initials":"GbWfLu","xLarge":"fkriwf","large":"SuHmO2","medium":"yfNZnj","small":"sKFD8h","xSmall":"Ish8Wi","xxSmall":"KB5MRm"};